<div class="card-popover job-popover card d-flex" *ngIf="Model">
    <div class="card-header highlightHeader">
        <div class="d-flex justify-content-between">
            <div class="statusIcon-Standard" [ngClass]="Model.StatusClass"></div>
            <div class="">{{Model.TemplateName}}</div>
            <button type="button" class="close" aria-label="Close" (click)="didTakeAction('close')">
                <span aria-hidden="true"><i class="fas fa-times-circle"></i></span>
            </button>
        </div>
    </div>
    <div class="card-title">
        <div class="d-flex justify-content-between border-bottom p-3">
            <div class="d-flex w-auto">
                <button type="button" class="btn btn-danger mr-2" *ngIf="Model.Status != QuestionSetStatus.Disabled" (click)="didTakeAction('deactivate')" translate>BTN.BTN_DEACTIVATE</button>
                <button type="button" class="btn btn-success mr-2" *ngIf="Model.Status != QuestionSetStatus.Active" (click)="didTakeAction('activate')" translate>BTN.BTN_ACTIVATE</button>
                
            </div>
            <div class="d-flex w-auto">
                <button type="button" class="btn btn-secondary mr-2" *ngIf="Model.Status == QuestionSetStatus.Pending" (click)="didTakeAction('edit')" translate>BTN.BTN_EDIT</button>
                <button type="button" class="btn btn-secondary mr-2" *ngIf="Model.Status != QuestionSetStatus.Pending" (click)="didTakeAction('clone')" translate>BTN.BTN_CLONE</button>
            </div>
        </div>
    </div>

    <div class="card-body container-fluid flex-fill">
        <div class="section-scroll">
            <div class="subSection">
                <div class="row">
                    <div class="col-4">
                        <span class="lblDisplay" translate>LBL.TIME_IN</span><br />{{Model.CreatedOnDate | amDateFormat: DateFormat}}
                    </div>
                    <div class="col-4" [ngClass]="{'text-success font-weight-bold': Model.Status == QuestionSetStatus.Active}">
                        <div *ngIf="Model.LastActivatedDate">
                            <span class="lblDisplay" translate>LBL.ACTIVATED</span><br />
                            <span class="d-inline-block mr-4">{{Model.LastActivatedDate | amDateFormat: DateFormat}}</span>
                        </div>
                    </div>
                    <div class="col-4" [ngClass]="{'text-danger font-weight-bold': Model.Status != QuestionSetStatus.Active}">
                        <div *ngIf="Model.LastDeactivatedDate">
                            <span class="lblDisplay" translate>LBL.DEACTIVATED</span>
                            <span class="d-inline-block mr-4">{{ Model.LastDeactivatedDate | amDateFormat: DateFormat}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="subSection">
                <div class="row">
                    <div class="col" *ngIf="ModelDetail">
                        <ul class="list-group list-group-flush" *ngIf="ModelDetail.Questions">
                            <li class="list-group-item d-flex flex-column" *ngFor="let question of ModelDetail.Questions; let index = index">
                                <p>
                                    Q{{question.Position + 1}}. {{question.QuestionText}}
                                    <span *ngIf="question.IsAnswerRequired">({{'ERR.ERR_REQUIRED' | translate}})</span>
                                </p>
                                <QuestionResponseView [Model]="question.AnswerOption"></QuestionResponseView>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
